module.exports = __webpack_public_path__ + "static/img/33.56a9b4c5.png";